const MapSkeleton = () => {
  return <div className="w-full h-[450px] bg-gray-300 rounded-3xl" />;
};

export default MapSkeleton;
